import { render, staticRenderFns } from "./TaskChartDetails.vue?vue&type=template&id=15adaebf&"
import script from "./TaskChartDetails.vue?vue&type=script&lang=js&"
export * from "./TaskChartDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports